class TestEventPerseus {
  constructor(_attributes: { bar: string }) {
    // no op
  }
}

export const events = {
  TestEventPerseus,
}
